import { render, staticRenderFns } from "./ResultGuideline.vue?vue&type=template&id=461b7256&"
import script from "./ResultGuideline.vue?vue&type=script&lang=js&"
export * from "./ResultGuideline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports